import isSuperadmin from '@/middlewares/isSuperadmin';
export default [
    /**
     * FOR SUPERADMIN ONLY
     */
    {
        path: '/superadmin-dashboard',
        component: () => import('@/views/superadmin/Dashboard.vue'),
        name: 'SuperadminDashboard',
        addtoNav: false,
        meta: {
            navText: 'Dashboard',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-master-products',
        component: () => import('@/views/superadmin/MasterProducts.vue'),
        name: 'SuperadminMasterProducts',
        addtoNav: false,
        meta: {
            navText: 'Master Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products',
        component: () => import('@/views/superadmin/v2/RegisteredProducts.vue'),
        // component: () => import('@/views/superadmin/RegisteredProducts.vue'),
        name: 'SuperadminRegisteredProducts',
        addtoNav: false,
        meta: {
            navText: 'Registered Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products',
        component: () => import('@/views/superadmin/v2/RegisteredProducts.vue'),
        name: 'SuperadminRegisteredProductsV2',
        addtoNav: false,
        meta: {
            navText: 'Registered Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products-request-warranty',
        component: () => import('@/views/superadmin/RegisteredProductsRequestWarranty.vue'),
        name: 'SuperadminRegisteredProductsRequestWarranty',
        addtoNav: false,
        meta: {
            navText: 'Request Warranties',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products-request-warranty/active',
        component: () => import('@/views/superadmin/RegisteredProductsActiveWarranty.vue'),
        name: 'SuperadminRegisteredProductsActiveWarranty',
        addtoNav: false,
        meta: {
            navText: 'Active Warranties',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products-request-warranty/closed',
        component: () => import('@/views/superadmin/RegisteredProductsClosedWarranty.vue'),
        name: 'SuperadminRegisteredProductsClosedWarranty',
        addtoNav: false,
        meta: {
            navText: 'Closed Warranties',
            middleware: [isSuperadmin]
        }
    },

    // Repairs

    {
        path: '/superadmin-registered-products-request-repair',
        component: () => import('@/views/superadmin/v2/RegisteredProductsRequestRepair.vue'),
        name: 'SuperadminRegisteredProductsRequestRepair',
        addtoNav: false,
        meta: {
            navText: 'Request Repairs',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products-request-repair/active',
        component: () => import('@/views/superadmin/v2/RegisteredProductsActiveRepair.vue'),
        name: 'SuperadminRegisteredProductsActiveRepair',
        addtoNav: false,
        meta: {
            navText: 'Active Repairs',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products-request-repair/closed',
        component: () => import('@/views/superadmin/v2/RegisteredProductsClosedRepair.vue'),
        name: 'SuperadminRegisteredProductsClosedRepair',
        addtoNav: false,
        meta: {
            navText: 'Closed Repairs',
            middleware: [isSuperadmin]
        }
    },

    // Repairs ends

    {
        path: '/superadmin-registered-products/add',
        component: () => import('@/views/superadmin/RegisteredProductsAdd.vue'),
        name: 'SuperadminRegisteredProductAdd',
        addtoNav: false,
        meta: {
            navText: 'Add Registered Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-registered-products/:id/edit',
        component: () => import('@/views/superadmin/RegisteredProductsEdit.vue'),
        name: 'SuperadminRegisteredProductEdit',
        addtoNav: false,
        meta: {
            navText: 'Edit Registered Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-distributors',
        component: () => import('@/views/superadmin/Distributors.vue'),
        name: 'SuperadminDistributors',
        addtoNav: false,
        meta: {
            navText: 'Distributors',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-distributor/:distributorid/resellers',
        component: () => import('@/views/superadmin/DistributorResellers.vue'),
        name: 'SuperadminDistributorResellers',
        addtoNav: false,
        meta: {
            navText: 'Distributor Resellers',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-distributor/:distributorid/customers',
        component: () => import('@/views/superadmin/DistributorCustomers.vue'),
        name: 'SuperadminDistributorCustomers',
        addtoNav: false,
        meta: {
            navText: 'Distributor Customers',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-distributors/:userid/products',
        component: () => import('@/views/superadmin/DistributorProducts.vue'),
        name: 'SuperadminDistributorProducts',
        addtoNav: false,
        meta: {
            navText: 'Superadmin Distributor Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-resellers',
        component: () => import('@/views/superadmin/Resellers.vue'),
        name: 'SuperadminResellers',
        addtoNav: false,
        meta: {
            navText: 'Resellers',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-resellers-map',
        component: () => import('@/views/superadmin/ResellersMap.vue'),
        name: 'SuperadminResellersMap',
        addtoNav: false,
        meta: {
            navText: 'Resellers Map',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-resellers/:userid/products',
        component: () => import('@/views/superadmin/ResellerProducts.vue'),
        name: 'SuperadminResellerProducts',
        addtoNav: false,
        meta: {
            navText: 'Superadmin Reseller Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-customers',
        component: () => import('@/views/superadmin/Customers.vue'),
        name: 'SuperadminCustomers',
        addtoNav: false,
        meta: {
            navText: 'End Users',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-customers/:userid/products',
        component: () => import('@/views/superadmin/CustomerProducts.vue'),
        name: 'SuperadminCustomerProducts',
        addtoNav: false,
        meta: {
            navText: 'Superadmin Users Products',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-customers/add',
        component: () => import('@/views/superadmin/CustomersAdd.vue'),
        name: 'SuperadminCustomersAdd',
        addtoNav: false,
        meta: {
            navText: 'Add User',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-customers/:id/edit',
        component: () => import('@/views/superadmin/CustomersEdit.vue'),
        name: 'SuperadminCustomersEdit',
        addtoNav: false,
        meta: {
            navText: 'Edit User',
            middleware: [isSuperadmin]
        }
    },

    {
        path: '/superadmin-report',
        component: () => import('@/views/superadmin/ReportWarrantyReport.vue'),
        name: 'SuperadminWarrantyReport',
        addtoNav: true,
        meta: {
            navText: 'Warranties',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-report/repair',
        component: () => import('@/views/superadmin/ReportRepairReport.vue'),
        name: 'SuperadminRepairReport',
        addtoNav: true,
        meta: {
            navText: 'Repairs',
            middleware: [isSuperadmin]
        }
    },
    {
        path: '/superadmin-report/depo-reseller-chart',
        component: () => import('@/views/superadmin/ResellerAndCustomerPieChart.vue'),
        name: 'SuperadminResellerCustomerPieChart',
        addtoNav: true,
        meta: {
            navText: 'Depos',
            middleware: [isSuperadmin]
        }
    }
];
